"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbAsisSessionStorage = void 0;
/* eslint-disable complexity */
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const framework_1 = require("../../../../framework");
class MbAsisSessionStorage extends framework_1.SessionStorage {
    constructor(store) {
        super(store);
    }
    getStoredData() {
        const accessToken = this.store.getItem('accessToken');
        const refreshToken = this.store.getItem('refreshToken');
        const username = this.store.getItem('username');
        const savedSessionExpiresAt = this.store.getItem('sessionExpiresAt');
        const sessionExpiresAt = (savedSessionExpiresAt === null || savedSessionExpiresAt === void 0 ? void 0 : savedSessionExpiresAt.trim()) ? new Date(savedSessionExpiresAt) : null;
        const savedExpiresIn = this.store.getItem('expiresIn');
        const expiresIn = savedExpiresIn ? Number(savedExpiresIn) : 0;
        if (accessToken && refreshToken && username) {
            return {
                accessToken,
                refreshToken,
                username,
                expiresIn,
                sessionExpiresAt,
            };
        }
        web_ui_framework_1.Log.warn('[MbAsisSessionStorage] can not get stored data. Pending fields storaged');
        return null;
    }
    setStoreNewData(newData) {
        const { accessToken, refreshToken, username, sessionExpiresAt, expiresIn } = newData;
        if (accessToken && refreshToken && username) {
            this.store.setItem('accessToken', accessToken);
            this.store.setItem('refreshToken', refreshToken);
            this.store.setItem('username', username);
            this.store.setItem('sessionExpiresAt', (sessionExpiresAt === null || sessionExpiresAt === void 0 ? void 0 : sessionExpiresAt.toISOString()) || '');
            this.store.setItem('expiresIn', expiresIn || 0);
        }
        else {
            web_ui_framework_1.Log.warn('[MbAsisSessionStorage] can not set new data. Pending fields in data');
        }
    }
    removeStoredSavedData() {
        this.store.removeItem('accessToken');
        this.store.removeItem('refreshToken');
        this.store.removeItem('username');
        this.store.removeItem('sessionExpiresAt');
        this.store.removeItem('expiresIn');
    }
}
exports.MbAsisSessionStorage = MbAsisSessionStorage;
//# sourceMappingURL=index.js.map